/**
 * Types + fetcher for GET /api/v1/me. The profile is read-only (EP.1802 DN-4):
 * name and email come from the directory, the role and access from DAQUMA.
 *
 * Types come from the OpenAPI-generated schema in `_generated/schema.d.ts`.
 * Regenerate via `pnpm gen:api` after a backend Pydantic change.
 */

import type { components } from "./_generated/schema";
import { apiFetch } from "./apiFetch";

export type Grant = components["schemas"]["daquma__api__v1__me__GrantOut"];
export type Me = components["schemas"]["MeOut"];

export function getMe(accessToken: string): Promise<Me> {
  return apiFetch<Me>("/api/v1/me", { token: accessToken });
}
